import React from 'react';

function Testimonials() {
  return (
    <>
      {/* ░░ TESTIMONIALS ░░ */}
<section className="testi-section" id="testimonials">
  <div className="testi-inner">
    <div className="animate-on-scroll" style={{textAlign: 'center', marginBottom: 'var(--space-xl)'}}>
      <div className="section-eyebrow" style={{justifyContent: 'center'}}>What Our Clients Say</div>
      <h2 className="section-h2">Trusted by fintech leaders<br /><em>across India.</em></h2>
    </div>
    <div className="testi-grid">

      <div className="testi-card animate-on-scroll" style={{transitionDelay: '.0s'}}>
        <div className="testi-stars">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
        </div>
        <div className="testi-quote-mark">"</div>
        <p className="testi-quote">SpeedVault's switch latency is genuinely under 50ms — we validated it ourselves. Our UPI success rate jumped from 94% to 99.6% within the first month. Nothing else we tried came close.</p>
        <div className="testi-author">
          <div className="testi-avatar" style={{background: 'linear-gradient(135deg,#0F172A,#0099D6)'}}>RK</div>
          <div>
            <div className="testi-name">Rahul Krishnamurthy</div>
            <div className="testi-role">CTO, FinBridge Technologies</div>
          </div>
          <div className="testi-badge">Fintech</div>
        </div>
      </div>

      <div className="testi-card animate-on-scroll featured" style={{transitionDelay: '.1s'}}>
        <div className="testi-stars">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
        </div>
        <div className="testi-quote-mark">"</div>
        <p className="testi-quote">We process over ₹500 crore monthly through SpeedVault. The fraud detection blocked 3,200+ suspicious transactions in Q1 alone — all without a single false positive that affected our real customers.</p>
        <div className="testi-author">
          <div className="testi-avatar" style={{background: 'linear-gradient(135deg,#7C3AED,#3EBC79)'}}>PM</div>
          <div>
            <div className="testi-name">Priya Mehta</div>
            <div className="testi-role">VP Engineering, KiraaPay</div>
          </div>
          <div className="testi-badge">Payments</div>
        </div>
      </div>

      <div className="testi-card animate-on-scroll" style={{transitionDelay: '.2s'}}>
        <div className="testi-stars">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFCE00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
        </div>
        <div className="testi-quote-mark">"</div>
        <p className="testi-quote">The API integration took our team 2 days, not 2 weeks like other providers quoted. The documentation is actually good. Their support team responds in under 15 minutes — every time.</p>
        <div className="testi-author">
          <div className="testi-avatar" style={{background: 'linear-gradient(135deg,#0099D6,#0F172A)'}}>AS</div>
          <div>
            <div className="testi-name">Arjun Sharma</div>
            <div className="testi-role">Head of Payments, RetailX India</div>
          </div>
          <div className="testi-badge">E-commerce</div>
        </div>
      </div>

    </div>
  </div>
</section>
    </>
  );
}

export default Testimonials;
